<div class="breadcrumbs cf-flex-row cf-justify-content-start cf-align-items-center">
  @for (link of links$ | async; track link.name) {
    <div
      class="breadcrumb cf-flex-row cf-justify-content-end cf-align-items-center"
      [ngClass]="{ active: link.active, previous: !link.next && !link.active }"
    >
      <a [routerLink]="link.url"
        ><span>{{ link.name | translate }}</span></a
      >
    </div>
    @if (link.active || !link.next) {
      <div class="arrow-container">
        <div class="arrow dark absolute" [ngClass]="{ 'active-arrow': link.active }"></div>
        <div class="arrow light absolute" [ngClass]="{ 'active-arrow': link.active }"></div>
      </div>
    }
  }
</div>
